/* eslint-disable max-lines */
/* eslint-disable no-nested-ternary */
/* eslint-disable sonarjs/cognitive-complexity */
// 9fbef606107a605d69c0edbcd8029e5d
/** @module PDP - Product Price
 */

import React from 'react';
import get from 'lodash/get';
import { PropTypes } from 'prop-types';
import { currencyConversion } from '@tcp/core/src/components/features/CnC/CartItemTile/utils/utils';
import Promotions from '@tcp/core/src/components/common/organisms/Promotions';
import PriceCurrency from '@tcp/core/src/components/common/molecules/PriceCurrency';
import { PRICING_VISIBLE } from '@tcp/core/src/constants/rum.constants';
import RenderPerf from '@tcp/web/src/components/common/molecules/RenderPerf';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary/errorBoundary';
import { PRICE_COLOR } from '@tcp/core/src/constants/brandSpecific.constants';
import AfterPayMessaging from '@tcp/core/src/components/common/organisms/AfterPayMessaging/container/AfterPayMessaging.container';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  getLabelWithDefaultValue,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { calculateFinalPrice } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/utils/productsCommonUtils.js';
import { PDP_SUB_LABELS, pdpSubLabels } from '@tcp/core/src/utils/labels/browse/PDP.labels';
import { PromotionalMessage } from '../../../ProductListing/molecules/ProductList/views/ProductItemComponents';
import { getBrand, getPromotionalMessage, getViewportInfo } from '../../../../../../utils';
import withStyles from '../../../../../common/hoc/withStyles';
import productPriceStyle, {
  VerticalSeperator,
  PriceAndAfterpayWrapper,
} from './ProductPrice.style';
import ProductItemPrice from '../ProductItemPrice/ProductItemPrice';
import ProductRating from '../ProductRating/ProductRating';
import StoreSpecialPriceTag from '../StoreSpecialPriceTag/StoreSpecialPriceTag';
import {
  ACCOUNT_ORDERS_LABEL,
  lblFinalSale,
  OrderDetailLabels,
} from '../../../../account/OrderDetails/container/OrderDetails.labels';

const getListPricePostFix = (highListPrice) => {
  return highListPrice ? (
    <>
      <span>- </span>
      <span className="post">
        <PriceCurrency price={highListPrice} />
      </span>
    </>
  ) : (
    ''
  );
};

const getListPricePostFixNewDesign = (highListPrice) => {
  return highListPrice ? (
    <>
      <span>&nbsp;-&nbsp;</span>
      <span className="post">
        <PriceCurrency price={highListPrice} />
      </span>
    </>
  ) : (
    ''
  );
};

const getHighOfferPrice = (highOfferPrice) => {
  return highOfferPrice ? (
    <>
      <span>- </span>
      <span className="post">
        <PriceCurrency price={highOfferPrice} />
      </span>
    </>
  ) : (
    ''
  );
};

const getHighOfferPriceNewDesign = (highOfferPrice) => {
  return highOfferPrice ? (
    <>
      <span>&nbsp;-&nbsp;</span>
      <span className="post">
        <PriceCurrency price={highOfferPrice} />
      </span>
    </>
  ) : (
    ''
  );
};
const getOnlyListPricePostFix = (onlyListPrice, listPrice) => {
  return listPrice || onlyListPrice;
};
const renderPointsAndReward = () => {
  const pointsAndRewardsTextLabel = getDynamicLabelValues(
    'dynamic.browse_d.lbl_brierley_promo_text_generic_pdp'
  );

  const pointsAndRewardsLabel = pointsAndRewardsTextLabel.split('##') || '';
  return pointsAndRewardsLabel ? (
    <BodyCopy component="p" className="points-and-rewards">
      {pointsAndRewardsLabel[0] && (
        <BodyCopy component="span" className="points-and-rewards-1">
          {pointsAndRewardsLabel[0]}
        </BodyCopy>
      )}
      {pointsAndRewardsLabel[1] && (
        <BodyCopy component="span" className="points-and-rewards-or">
          {pointsAndRewardsLabel[1]}
        </BodyCopy>
      )}
      {pointsAndRewardsLabel[2] && (
        <BodyCopy component="span" className="points-and-rewards-2">
          {pointsAndRewardsLabel[2]}
        </BodyCopy>
      )}
    </BodyCopy>
  ) : null;
};
class ProductPrice extends React.Component {
  pointsAndRewardsTextLabel = getDynamicLabelValues(
    'dynamic.browse_d.lbl_brierley_promo_text_generic_pdp'
  );

  singleLabel = getLabelFromCopyOrFromTranslation(
    `${PDP_SUB_LABELS}.lbl_multipack_single_text`,
    pdpSubLabels
  );

  static propTypes = {
    isItemPartNumberVisible: PropTypes.bool.isRequired,
    currencySymbol: PropTypes.string.isRequired,
    listPrice: PropTypes.number.isRequired,
    hideItemProp: PropTypes.bool, // prop is used to hide unwanted duplicate itemProp as we have duplicate ProductPrice component for web and mobile on PDP pages
    offerPrice: PropTypes.number,
    highOfferPrice: PropTypes.number,
    highListPrice: PropTypes.number,
    itemPartNumber: PropTypes.string,
    currencyExchange: PropTypes.shape({}),
    promotionalMessage: PropTypes.string,
    isPlcc: PropTypes.bool.isRequired,
    promotionalPLCCMessage: PropTypes.string,
    badge2: PropTypes.string,
    favIconContainer: PropTypes.shape({}),
    currencyAttributes: PropTypes.shape({}).isRequired,
    customFonts: PropTypes.shape({ listPriceFont: PropTypes.string }),
    className: PropTypes.string,
    isInternationalShipping: PropTypes.bool.isRequired,
    onlyListPrice: PropTypes.number,
    // currencySign: PropTypes.string,
    fromBagPage: PropTypes.bool.isRequired,
    isGiftCard: PropTypes.bool.isRequired,
    productInfoFromBag: PropTypes.shape({}).isRequired,
    isOutfitPage: PropTypes.bool,
    TCPMultipackProductMapping: PropTypes.shape([]),
    selectedMultipack: PropTypes.string,
    isPerUnitPriceEnabled: PropTypes.bool,
    isStyleWith: PropTypes.bool,
    productInfo: PropTypes.shape({}),
    isBrierleyPromoEnabled: PropTypes.bool,
    TCPStyleQTY: PropTypes.string,
    isAfterPayDisplay: PropTypes.bool,
    isNewQVEnabled: PropTypes.bool,
    isNewPDPEnabled: PropTypes.bool,
    fromPickUp: PropTypes.bool,
    renderProductRatings: PropTypes.func,
    isQuickView: PropTypes.bool,
    isNewPJPPDPRedesignEnabled: PropTypes.bool,
    preOrderDate: PropTypes.string,
    priceRange: PropTypes.shape({}),
    isStoreSpecialsPriceOn: PropTypes.bool,
    colorProduct: PropTypes.shape({
      miscInfo: PropTypes.shape({
        isClearance: PropTypes.string,
      }),
    }),
  };

  static defaultProps = {
    offerPrice: null,
    itemPartNumber: '',
    currencyExchange: {},
    promotionalMessage: '',
    promotionalPLCCMessage: '',
    highOfferPrice: '',
    onlyListPrice: '',
    hideItemProp: false,
    highListPrice: '',
    badge2: '',
    favIconContainer: null,
    className: '',
    customFonts: {},
    // currencySign: '',
    isOutfitPage: false,
    TCPMultipackProductMapping: [],
    selectedMultipack: '1',
    isPerUnitPriceEnabled: false,
    isStyleWith: false,
    productInfo: {},
    isBrierleyPromoEnabled: false,
    TCPStyleQTY: '',
    isAfterPayDisplay: false,
    isNewQVEnabled: false,
    fromPickUp: false,
    renderProductRatings: () => {},
    isNewPDPEnabled: false,
    isQuickView: false,
    isNewPJPPDPRedesignEnabled: false,
    preOrderDate: '',
    priceRange: {},
    isStoreSpecialsPriceOn: false,
    colorProduct: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      isPriceVisible: false,
      hasMounted: false,
    };
    this.afterPayPrice = 0;
  }

  accountDetailLabels = getLabelFromCopyOrFromTranslation(ACCOUNT_ORDERS_LABEL, OrderDetailLabels);

  componentDidMount() {
    const { listPrice, offerPrice, highOfferPrice, highListPrice, onlyListPrice } = this.props;
    if (listPrice || offerPrice || highOfferPrice || highListPrice || onlyListPrice) {
      this.setState({ isPriceVisible: true });
    }
    this.setState({ hasMounted: true });
  }

  getBadge = (badge2, isPriceRange, isHideOriginalPrice) => {
    return badge2 && !isHideOriginalPrice ? (
      <BodyCopy
        className="badge"
        color="red.600"
        fontSize={isPriceRange ? ['fs11', 'fs14', 'fs14'] : 'fs14'}
        fontWeight="semibold"
        fontFamily="secondary"
      >
        {badge2}
      </BodyCopy>
    ) : null;
  };

  getPerItemPrice = (offerPrice, giftCardPrice) => {
    const { selectedMultipack, isPerUnitPriceEnabled, TCPStyleQTY } = this.props;
    const selectedMpackCount = TCPStyleQTY || selectedMultipack;
    const showPerPrice =
      selectedMpackCount &&
      String(selectedMpackCount).toLowerCase() !== this.singleLabel.toLowerCase() &&
      String(selectedMpackCount) !== '1';

    return showPerPrice && isPerUnitPriceEnabled ? (
      <ProductItemPrice
        packPrice={this.getGiftCardOrOfferPrice(offerPrice, giftCardPrice)}
        selectedMultipack={selectedMpackCount}
      />
    ) : null;
  };

  isCurrencyExchangeValid = (currencyAttributes) =>
    currencyAttributes && currencyAttributes.exchangevalue;

  getBundlePriceList = (highOfferPrice, highListPrice, listPrice) => {
    return (!!highOfferPrice || !!highListPrice) && highListPrice !== listPrice;
  };

  getBothPrice = (offerPrice, listPrice, highOfferPrice, highListPrice) => {
    return (
      (offerPrice && offerPrice !== listPrice) ||
      (highOfferPrice && highOfferPrice !== highListPrice)
    );
  };

  getPriceColor = () => {
    const brandId = getBrand();
    return PRICE_COLOR[brandId.toUpperCase()];
  };

  getGiftCardPrice = () => {
    const { fromBagPage, isGiftCard, productInfoFromBag } = this.props;
    if (fromBagPage && isGiftCard) {
      return parseInt(productInfoFromBag.selectedSize, 10);
    }
    return null;
  };

  getGiftCardOrOfferPrice = (offerPrice, giftCardPrice) => {
    return giftCardPrice || offerPrice;
  };

  productRatingCheck = (isGiftCard, isStyleWith) => {
    return !isGiftCard && isStyleWith;
  };

  // eslint-disable-next-line complexity
  getPriceMarkUp = (styleClass = '', storeSpecialObj) => {
    let { listPrice, offerPrice, highOfferPrice, highListPrice, onlyListPrice } = this.props;
    const { badge2, priceRange = {} } = this.props;
    const { showStoreSpeciaPrice, storeSpecialFinalPriceWithoutPromo } = storeSpecialObj || {};
    const {
      className,
      currencyAttributes,
      customFonts: { listPriceFont },
      isOutfitPage,
      isNewQVEnabled,
      isNewPDPEnabled,
      isFbt,
      isQuickView,
      isHideOriginalPrice,
      isPickupSelectedAtProductDetail,
    } = this.props;

    if (this.isCurrencyExchangeValid(currencyAttributes)) {
      offerPrice = currencyConversion(offerPrice, currencyAttributes);
      listPrice = currencyConversion(listPrice, currencyAttributes);
      highOfferPrice = currencyConversion(
        highOfferPrice || priceRange?.highOfferPrice,
        currencyAttributes
      );
      highListPrice = currencyConversion(
        highListPrice || priceRange?.highListPrice,
        currencyAttributes
      );
      onlyListPrice = currencyConversion(
        onlyListPrice || priceRange?.onlyListPrice,
        currencyAttributes
      );
    }
    const listPricePostFix = getListPricePostFix(highListPrice);
    const offerPricePostFix = getHighOfferPrice(highOfferPrice);
    const isPriceRange = Boolean(highListPrice || highOfferPrice);
    const onlyListPriceInfo = getOnlyListPricePostFix(onlyListPrice, listPrice);
    const showBothPrice = this.getBothPrice(offerPrice, listPrice, highOfferPrice, highListPrice);
    const offerPriceFontSize = isFbt ? 'fs14' : 'fs22';

    const bundleListPrice = this.getBundlePriceList(highOfferPrice, highListPrice, listPrice);
    const priceColor = this.getPriceColor();
    const giftCardPrice = this.getGiftCardPrice();
    const perItemPrice = this.getPerItemPrice(offerPrice, giftCardPrice);
    if (showBothPrice) {
      this.afterPayPrice = offerPrice;
      return (
        <div
          className={`${className} price-container ${styleClass} ${
            isNewQVEnabled || isNewPDPEnabled ? 'quick-view-drawer-redesign' : ''
          }`}
          isQuickView={isQuickView}
        >
          <BodyCopy
            className={`${
              isFbt
                ? 'fbt-price'
                : `price-item actual-price ${isPriceRange ? 'offer-price-product' : ''}`
            }`}
            fontSize={offerPriceFontSize}
            fontFamily="secondary"
            fontWeight="extrabold"
            color={priceColor}
          >
            {isPickupSelectedAtProductDetail && showStoreSpeciaPrice ? (
              <PriceCurrency price={storeSpecialFinalPriceWithoutPromo} />
            ) : (
              <>
                <PriceCurrency price={offerPrice} />
                {offerPricePostFix}
              </>
            )}
          </BodyCopy>
          {perItemPrice}
          {!(isPickupSelectedAtProductDetail && showStoreSpeciaPrice) && (
            <div className={`list-badge-container ${isFbt ? 'fbt-price-original' : ''}`}>
              {!isHideOriginalPrice && (
                <BodyCopy
                  className={`price-item original-price ${
                    isPriceRange ? 'list-price-product' : ''
                  }`}
                  fontSize={listPriceFont || 'fs14'}
                  fontFamily="secondary"
                  fontWeight="semibold"
                  color="gray.600"
                >
                  {/* TODO - fix it with bundle {!(isBundleProduct || isBundleList) ? 'Was' : ''}  */}

                  <span className="pre">
                    <PriceCurrency price={listPrice} />
                  </span>
                  {listPricePostFix}
                </BodyCopy>
              )}
              {this.getBadge(badge2, isPriceRange, isHideOriginalPrice)}
            </div>
          )}
        </div>
      );
    }
    this.afterPayPrice = this.getGiftCardOrOfferPrice(offerPrice, giftCardPrice);
    if (this.afterPayPrice) {
      return (
        <>
          {!isHideOriginalPrice && (
            <BodyCopy
              className="price-item actual-price"
              fontSize={offerPriceFontSize}
              fontFamily="secondary"
              fontWeight="black"
              color={priceColor}
            >
              {isPickupSelectedAtProductDetail && showStoreSpeciaPrice ? (
                <PriceCurrency price={storeSpecialFinalPriceWithoutPromo} />
              ) : (
                <>
                  <PriceCurrency price={this.afterPayPrice} />
                  {offerPricePostFix}
                </>
              )}
            </BodyCopy>
          )}
          {perItemPrice}
        </>
      );
    }

    if (bundleListPrice) {
      this.afterPayPrice = listPrice;
      return (
        <>
          {!isHideOriginalPrice && (
            <BodyCopy
              className="price-item actual-price"
              fontSize={offerPriceFontSize}
              fontFamily="secondary"
              fontWeight="black"
              color={priceColor}
            >
              <PriceCurrency price={listPrice} />
              {listPricePostFix}
            </BodyCopy>
          )}
          {perItemPrice}
        </>
      );
    }

    this.afterPayPrice = onlyListPriceInfo;
    return (
      <>
        {!isHideOriginalPrice && (
          <BodyCopy
            className="price-item actual-price"
            fontSize={isOutfitPage ? ['fs22'] : 'fs16'}
            fontFamily="secondary"
            fontWeight="black"
            color={priceColor}
          >
            <PriceCurrency price={onlyListPriceInfo} />
          </BodyCopy>
        )}
        {perItemPrice}
      </>
    );
  };

  renderPriceMarkUpRedesign = ({
    showBothPrice,
    offerPrice,
    className,
    isPriceRange,
    offerPricePostFix,
    perItemPrice,
    isHideOriginalPrice,
    listPrice,
    listPricePostFix,
    badge2,
    giftCardPrice,
    bundleListPrice,
    onlyListPriceInfo,
    showStoreSpecialPrice,
    storeSpecialFinalPriceWithoutPromo,
    isPickupSelectedAtProductDetail,
    tmpPromotionalPrice,
  }) => {
    const storeSpecialCheck = showStoreSpecialPrice && isPickupSelectedAtProductDetail;
    const isPriceOnIframe = !!tmpPromotionalPrice;
    if (showBothPrice) {
      this.afterPayPrice = offerPrice;
      return (
        <div className={`${className} pdp-redesign-price-component`}>
          <BodyCopy className="price-item actual-price" fontFamily="secondary">
            {storeSpecialCheck ? (
              <PriceCurrency
                price={storeSpecialFinalPriceWithoutPromo}
                isPriceOnIframe={isPriceOnIframe}
              />
            ) : (
              <>
                <PriceCurrency price={offerPrice} isPriceOnIframe={isPriceOnIframe} />
                {offerPricePostFix}
              </>
            )}
          </BodyCopy>
          {perItemPrice}
          {!isHideOriginalPrice && !storeSpecialCheck && (
            <div className={`list-badge-container ${showStoreSpecialPrice ? 'store-spl-cls' : ''}`}>
              <BodyCopy className="price-item original-price" fontFamily="secondary">
                <span className="pre">
                  <PriceCurrency price={listPrice} />
                </span>
                {listPricePostFix}
              </BodyCopy>
              {this.getBadge(badge2, isPriceRange, isHideOriginalPrice)}
            </div>
          )}
        </div>
      );
    }
    this.afterPayPrice = this.getGiftCardOrOfferPrice(offerPrice, giftCardPrice);
    if (this.afterPayPrice) {
      return (
        <>
          {!isHideOriginalPrice && (
            <BodyCopy className="price-item actual-price" fontFamily="secondary">
              {storeSpecialCheck ? (
                <PriceCurrency
                  price={storeSpecialFinalPriceWithoutPromo}
                  isPriceOnIframe={isPriceOnIframe}
                />
              ) : (
                <>
                  <PriceCurrency price={this.afterPayPrice} isPriceOnIframe={isPriceOnIframe} />
                  {offerPricePostFix}
                </>
              )}
            </BodyCopy>
          )}
          {perItemPrice}
        </>
      );
    }

    if (bundleListPrice) {
      this.afterPayPrice = listPrice;
      return (
        <>
          {!isHideOriginalPrice && (
            <BodyCopy className="price-item actual-price" fontFamily="secondary">
              <PriceCurrency price={listPrice} isPriceOnIframe={isPriceOnIframe} />
              {listPricePostFix}
            </BodyCopy>
          )}
          {perItemPrice}
        </>
      );
    }

    this.afterPayPrice = onlyListPriceInfo;
    return (
      <>
        {!isHideOriginalPrice && (
          <BodyCopy className="price-item actual-price" fontFamily="secondary">
            <PriceCurrency price={onlyListPriceInfo} isPriceOnIframe={isPriceOnIframe} />
          </BodyCopy>
        )}
        {perItemPrice}
      </>
    );
  };

  // eslint-disable-next-line complexity
  getPriceMarkUpRedesign = () => {
    let { listPrice, offerPrice, highOfferPrice, highListPrice, onlyListPrice } = this.props;
    const {
      badge2,
      priceRange = {},
      preOrderDate,
      className,
      currencyAttributes,
      isHideOriginalPrice,
      promotionPrice,
      isStoreSpecialsPriceOn,
      storeSpecialDiscount,
      isPickupSelectedAtProductDetail,
      storeSpecials,
      hideStoreSpecial,
      TCPPromotionPrice,
      TCPPromotionID,
      activePromotions = [],
      storeSpecialPriceRange,
      defaultStoreId,
      storeSpecialInCurrentStore,
      colorProduct,
      isFinalSaleMessageEnabled,
    } = this.props;
    // const { storeSpecials } = productInfo;
    const isClearance = get(colorProduct, 'miscInfo.isClearance');
    if (this.isCurrencyExchangeValid(currencyAttributes)) {
      offerPrice = currencyConversion(offerPrice, currencyAttributes);
      listPrice = currencyConversion(listPrice, currencyAttributes);
      highOfferPrice = currencyConversion(
        highOfferPrice || priceRange?.highOfferPrice,
        currencyAttributes
      );
      highListPrice = currencyConversion(
        highListPrice || priceRange?.highListPrice,
        currencyAttributes
      );
      onlyListPrice = currencyConversion(
        onlyListPrice || priceRange?.onlyListPrice,
        currencyAttributes
      );
    }
    const { isDesktop = true } = getViewportInfo() || {};
    const listPricePostFix = getListPricePostFixNewDesign(highListPrice);
    const offerPricePostFix = getHighOfferPriceNewDesign(highOfferPrice);
    const isPriceRange = Boolean(highListPrice || highOfferPrice);
    const onlyListPriceInfo = getOnlyListPricePostFix(onlyListPrice, listPrice);
    const showBothPrice = this.getBothPrice(offerPrice, listPrice, highOfferPrice, highListPrice);

    const bundleListPrice = this.getBundlePriceList(highOfferPrice, highListPrice, listPrice);
    const giftCardPrice = this.getGiftCardPrice();
    const perItemPrice = this.getPerItemPrice(offerPrice, giftCardPrice);
    const showStoreSpecialPrice =
      isStoreSpecialsPriceOn && storeSpecials && storeSpecialInCurrentStore;
    let storeSpecialFinalPriceWithoutPromo;
    const tmpPromotionalPrice =
      TCPPromotionID && activePromotions[TCPPromotionID] ? TCPPromotionPrice : '';
    let storeSpecialFinalPrice = tmpPromotionalPrice;
    if (showStoreSpecialPrice) {
      storeSpecialFinalPrice = calculateFinalPrice(
        offerPrice,
        storeSpecialDiscount,
        tmpPromotionalPrice,
        storeSpecialPriceRange,
        defaultStoreId
      );
      storeSpecialFinalPriceWithoutPromo = calculateFinalPrice(
        offerPrice,
        storeSpecialDiscount,
        '',
        storeSpecialPriceRange,
        defaultStoreId
      );
    }
    return (
      <>
        <PriceAndAfterpayWrapper
          className={`${className} pdp-redesign-price-and-afterpay-wrapper`}
          isPriceRange={isPriceRange}
          showStoreSpecialPrice={showStoreSpecialPrice}
        >
          <div
            className={`pdp-redesign-price-component-wrapper ${
              showStoreSpecialPrice ? 'showStoreSpecialPriceWrapper' : ''
            }`}
          >
            {this.renderPriceMarkUpRedesign({
              showBothPrice,
              offerPrice,
              className,
              promotionPrice,
              isPriceRange,
              offerPricePostFix,
              perItemPrice,
              isHideOriginalPrice,
              listPrice,
              listPricePostFix,
              badge2,
              giftCardPrice,
              bundleListPrice,
              onlyListPriceInfo,
              showStoreSpecialPrice,
              storeSpecialFinalPrice,
              isPickupSelectedAtProductDetail,
              storeSpecialFinalPriceWithoutPromo,
              tmpPromotionalPrice,
            })}

            {showStoreSpecialPrice && !hideStoreSpecial && (
              <>
                <VerticalSeperator
                  className="vertical-seperator showStoreSpecialPriceSeparator"
                  isPriceRange={isPriceRange}
                />
                <div className="store-special">
                  <StoreSpecialPriceTag
                    offerPrice={`${offerPrice}${offerPricePostFix}`}
                    storeSpecialPrice={storeSpecialFinalPrice}
                    isPickupSelectedAtProductDetail={isPickupSelectedAtProductDetail}
                    TCPPromotionPrice={tmpPromotionalPrice}
                  />
                </div>
              </>
            )}
          </div>

          {this.afterPayCheck() && (
            <>
              {!showStoreSpecialPrice && (
                <VerticalSeperator className="vertical-seperator" isPriceRange={isPriceRange} />
              )}
              <AfterPayMessaging
                offerPrice={this.afterPayPrice}
                preOrderDate={preOrderDate}
                isPDPRedesignAfterPayMessage
              />
            </>
          )}
        </PriceAndAfterpayWrapper>
        {!isDesktop && isClearance?.toLowerCase() === 'clearance' && isFinalSaleMessageEnabled && (
          <BodyCopy
            fontFamily="secondary"
            fontSize={['fs10', 'fs10', 'fs12']}
            fontWeight="semibold"
            color={'gray.800'}
            customStyle={{ marginTop: '8px', marginBottom: '8px' }}
            letterSpacing="0.25px"
          >
            {getLabelWithDefaultValue(this.accountDetailLabels, lblFinalSale)}
          </BodyCopy>
        )}
      </>
    );
  };

  redesignCheck = () => {
    const { isNewQVEnabled, isNewPDPEnabled, isNewPJPPDPRedesignEnabled } = this.props;
    return isNewQVEnabled || isNewPDPEnabled || isNewPJPPDPRedesignEnabled;
  };

  afterPayCheck = () => {
    const { isAfterPayDisplay, isGiftCard, fromBagPage } = this.props;
    return isAfterPayDisplay && !isGiftCard && !(this.redesignCheck() && fromBagPage);
  };

  showPromotions = ({
    isQuickView,
    TCPPromotionPrice,
    TCPPromotionID,
    isUpdatedPromotionsDisplayEnabled,
    isPickupSelectedAtProductDetail,
    storeSpecialFinalPrice,
    storeSpecials,
  }) => {
    const { productInfo } = this.props;
    const { primaryBrand, alternateBrand } = productInfo;
    return (
      isQuickView && (
        <Promotions
          underLine
          showArrow
          showIcon={false}
          showHeading
          pageName="QV"
          brand={primaryBrand || alternateBrand}
          TCPPromotionPrice={TCPPromotionPrice}
          TCPPromotionID={TCPPromotionID}
          isUpdatedPromotionsDisplayEnabled={isUpdatedPromotionsDisplayEnabled}
          TCPPromotionPriceStoreSpecial={storeSpecialFinalPrice}
          isPickupSelectedAtProductDetail={isPickupSelectedAtProductDetail}
          storeSpecials={storeSpecials}
        />
      )
    );
  };

  // eslint-disable-next-line complexity
  render() {
    const {
      isItemPartNumberVisible,
      itemPartNumber,
      promotionalMessage,
      // isCanada,
      promotionalPLCCMessage,
      isPlcc,
      isInternationalShipping,
      // isBundleProduct,
      className,
      // isBundleList,
      isGiftCard,
      isStyleWith,
      productInfo: { ratings, reviewsCount, unbxdRatings, unbxdReviewsCount },
      isBrierleyPromoEnabled,
      fromPickUp,
      renderProductRatings,
      productInfo,
      isNewQVEnabled,
      fromBagPage,
      isNewPDPEnabled,
      isFbt,
      isQuickView,
      preOrderDate,
      isNewPJPPDPRedesignEnabled,
      primaryBrand,
      isPDPRedesignEnabled,
      isPDPRedesignPrice,
      setPromotionPrice,
      isShowPromoPriceMicroData,
      TCPPromotionPrice,
      TCPPromotionID,
      isUpdatedPromotionsDisplayEnabled,
      storeSpecialPriceFlag,
      storeSpecialDiscount,
      offerPrice,
      isPickupSelectedAtProductDetail,
      hideStoreSpecial,
      activePromotions = [],
      storeSpecials,
      storeSpecialPriceRange,
      defaultStoreId,
      storeSpecialInCurrentStore,
    } = this.props;
    const { isPriceVisible } = this.state;
    const afterPayMessageWrapper = 'afterPay-msg-wrapper';

    const isFromBagPageClass = fromBagPage ? ' price-container-bagPage' : '';
    let storeSpecialFinalPriceWithoutPromo;
    const tmpPromotionalPrice =
      TCPPromotionID && activePromotions[TCPPromotionID] ? TCPPromotionPrice : '';
    let storeSpecialFinalPrice = tmpPromotionalPrice;
    const showStoreSpeciaPrice = storeSpecialPriceFlag && storeSpecialInCurrentStore;
    if (showStoreSpeciaPrice) {
      storeSpecialFinalPrice = calculateFinalPrice(
        offerPrice,
        storeSpecialDiscount,
        tmpPromotionalPrice,
        storeSpecialPriceRange,
        defaultStoreId
      );
      storeSpecialFinalPriceWithoutPromo = calculateFinalPrice(
        offerPrice,
        storeSpecialDiscount,
        '',
        storeSpecialPriceRange,
        defaultStoreId
      );
    }
    return (
      <section className={`${className} product-price-container${isFromBagPageClass}`}>
        <div>
          {this.redesignCheck() && !isPDPRedesignPrice && !fromBagPage && (
            <>
              {showStoreSpeciaPrice && (
                <div className="store-spl-rating-cls">
                  {renderProductRatings(
                    productInfo,
                    isNewQVEnabled,
                    isNewPDPEnabled,
                    null,
                    null,
                    isPDPRedesignEnabled
                  )}
                </div>
              )}
              <div
                className={`price-rating-section show-on-mobile-qv ${
                  showStoreSpeciaPrice ? 'store-spl-price-cls' : ''
                }`}
              >
                <div className="price-section-left">
                  {this.getPriceMarkUp('show-on-mobile-qv', {
                    storeSpecialFinalPriceWithoutPromo,
                    showStoreSpeciaPrice,
                  })}
                </div>
                <div
                  className={`rating-section-right ${
                    showStoreSpeciaPrice ? 'store-spl-price-section' : ''
                  }`}
                >
                  {showStoreSpeciaPrice && !hideStoreSpecial ? (
                    <>
                      <VerticalSeperator
                        className="vertical-seperator showStoreSpecialPriceSeparatorQV"
                        isPriceRange={false}
                      />
                      <StoreSpecialPriceTag
                        offerPrice={`${offerPrice}`}
                        storeSpecialPrice={storeSpecialFinalPrice}
                        isPickupSelectedAtProductDetail={isPickupSelectedAtProductDetail}
                        fromQV
                        TCPPromotionPrice={tmpPromotionalPrice}
                      />
                    </>
                  ) : (
                    !hideStoreSpecial &&
                    renderProductRatings(
                      productInfo,
                      isNewQVEnabled,
                      isNewPDPEnabled,
                      null,
                      null,
                      isPDPRedesignEnabled
                    )
                  )}
                </div>
              </div>
              {!isQuickView && TCPPromotionID && (
                <Promotions
                  underLine
                  showArrow
                  showIcon={false}
                  showHeading
                  className="isPDP show-on-mobile"
                  isStyleWith={isStyleWith}
                  pageName="PDP"
                  brand={primaryBrand}
                  isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
                  setPromotionPrice={setPromotionPrice}
                  isShowPromoPriceMicroData={isShowPromoPriceMicroData}
                  TCPPromotionPrice={TCPPromotionPrice}
                  TCPPromotionID={TCPPromotionID}
                  isUpdatedPromotionsDisplayEnabled={isUpdatedPromotionsDisplayEnabled}
                  TCPPromotionPriceStoreSpecial={storeSpecialFinalPrice}
                  isPickupSelectedAtProductDetail={isPickupSelectedAtProductDetail}
                  storeSpecials={storeSpecials}
                />
              )}
              {isQuickView &&
                this.showPromotions({
                  isQuickView,
                  TCPPromotionPrice,
                  TCPPromotionID,
                  isUpdatedPromotionsDisplayEnabled,
                  storeSpecialFinalPrice,
                  isPickupSelectedAtProductDetail,
                  storeSpecials,
                })}
            </>
          )}
          {isPDPRedesignPrice ? (
            <>{this.getPriceMarkUpRedesign()}</>
          ) : isNewPJPPDPRedesignEnabled ? (
            <div className="price-afterpay-section show-on-desktop">
              <div className="price-section-left">{this.getPriceMarkUp('show-on-desktop')}</div>
              <div className="afterpay-section-right">
                <div className={`newafterPay ${fromPickUp ? afterPayMessageWrapper : ''}`}>
                  <AfterPayMessaging offerPrice={this.afterPayPrice} preOrderDate={preOrderDate} />
                </div>
              </div>
            </div>
          ) : (
            <div className={this.redesignCheck() && !fromBagPage ? 'show-on-desktop' : ''}>
              {this.getPriceMarkUp('', {
                showStoreSpeciaPrice,
                storeSpecialFinalPriceWithoutPromo,
              })}
            </div>
          )}
          {!isNewPDPEnabled && this.afterPayCheck() && !isNewPJPPDPRedesignEnabled && (
            <div
              className={`${fromPickUp ? afterPayMessageWrapper : 'afterpay-messaging-section'}`}
            >
              <AfterPayMessaging offerPrice={this.afterPayPrice} preOrderDate={preOrderDate} />
            </div>
          )}
          {isPriceVisible && <RenderPerf.Measure name={PRICING_VISIBLE} />}
          {isItemPartNumberVisible && (
            <strong className="number-item">
              Item #:
              {itemPartNumber}
            </strong>
          )}
        </div>
        {isPDPRedesignPrice
          ? null
          : isBrierleyPromoEnabled
          ? renderPointsAndReward()
          : promotionalMessage &&
            !isStyleWith &&
            !isFbt && (
              // Adding this exception as prettier is formating it against the indentation rules
              // eslint-disable-next-line react/jsx-indent
              <PromotionalMessage
                isBrierleyPromoEnabled={isBrierleyPromoEnabled}
                isInternationalShipping={isInternationalShipping}
                text={getPromotionalMessage(isPlcc, {
                  promotionalMessage,
                  promotionalPLCCMessage,
                })}
              />
            )}

        {isNewPDPEnabled &&
          !isPDPRedesignPrice &&
          this.afterPayCheck() &&
          (!isNewPJPPDPRedesignEnabled || isNewPJPPDPRedesignEnabled) && (
            <div
              className={`newafterPay show-on-mobile ${fromPickUp ? afterPayMessageWrapper : ''}`}
            >
              <AfterPayMessaging offerPrice={this.afterPayPrice} preOrderDate={preOrderDate} />
            </div>
          )}
        {this.productRatingCheck(isGiftCard, isStyleWith) ? (
          <ProductRating
            ratings={ratings || unbxdRatings || 0}
            reviews={reviewsCount || unbxdReviewsCount}
          />
        ) : null}
        {fromBagPage &&
          this.showPromotions({
            isQuickView,
            TCPPromotionPrice,
            TCPPromotionID,
            isUpdatedPromotionsDisplayEnabled,
          })}
      </section>
    );
  }
}

export default errorBoundary(withStyles(ProductPrice, productPriceStyle));
